(() => {
 const lazyObserver = new IntersectionObserver(entries => {
   entries.forEach(entry => {
     if (!entry.isIntersecting) return;
     const root = entry.target;
     const template = root.querySelector('template[data-order-lazy]');
     if (!template) return;
     root.append(template.content.cloneNode(true));
     template.remove();
     root.style.minHeight = '';
     lazyObserver.unobserve(root);
     mount();
   });
 }, { rootMargin: '250px 0px' });
 const mount = () => {
 const target = document.querySelector('[data-order-sections]');
 if (!target) return;
 if(!window.Shopify?.designMode){
 document.querySelectorAll('.ds-order-section').forEach(wrapper => {
 const id=wrapper.id;
 let anchor=document.querySelector('[data-order-anchor="'+id+'"]');
 if(!anchor){anchor=document.createElement('span');anchor.hidden=true;anchor.dataset.orderAnchor=id;wrapper.before(anchor);}
 });
 document.querySelectorAll('[data-order-anchor]').forEach(anchor=>{const wrapper=document.getElementById(anchor.dataset.orderAnchor);if(wrapper)target.append(wrapper);});
 }
 document.querySelectorAll('.ds-order-section').forEach(root=>{
 if(root.querySelector('template[data-order-lazy]')){
   root.style.minHeight='320px';
   lazyObserver.observe(root);
   return;
 }
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const config=target.closest('.ds-configurator');
 root.addEventListener('click',event=>{if(event.target.closest('[data-order-form-link]'))config.querySelector('.ds-order-buy').click();});
 const setStep=()=>config.querySelector('.ds-configurator__continue').click();
 root.addEventListener('shopify:section:select',setStep);
 root.addEventListener('shopify:block:select',setStep);
      const reviews = [...root.querySelectorAll('.ds-review')];
      const reviewFilter = root.querySelector('[data-review-filter]');
      const pagination = root.querySelector('.ds-reviews__pagination');
      let reviewPage = 1;
      const renderReviews = () => {
        root.querySelector('.ds-reviews__track')?.scrollTo({left:0,behavior:'instant'});
        const filtered = reviews.filter(review => reviewFilter?.value !== 'photos' || review.dataset.hasPhoto === 'true');
        const pages = Math.max(1, Math.ceil(filtered.length / 4));
        reviewPage = Math.max(1, Math.min(reviewPage, pages));
        reviews.forEach(review => { review.hidden = true; });
        filtered.slice((reviewPage - 1) * 4, reviewPage * 4).forEach(review => { review.hidden = false; });
        if (pagination) {
          pagination.hidden = pages <= 1;
          pagination.querySelector('[data-review-page]').textContent = `${reviewPage} / ${pages}`;
          pagination.querySelector('[data-review-prev]').disabled = reviewPage === 1;
          pagination.querySelector('[data-review-next]').disabled = reviewPage === pages;
        }
      };
      reviewFilter?.addEventListener('change', () => { reviewPage = 1; renderReviews(); });
      pagination?.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        reviewPage += button.hasAttribute('data-review-next') ? 1 : -1;
        renderReviews();
        root.querySelector('.ds-reviews').scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      root.addEventListener('shopify:block:select', event => {
        setStep(2);
        const index = reviews.indexOf(event.target.closest('.ds-review'));
        if (index >= 0) { reviewFilter.value = 'all'; reviewPage = Math.floor(index / 4) + 1; renderReviews(); }
      });
      renderReviews();

      root.querySelectorAll('[data-sequence]').forEach(sequence => {
        const frames = [...sequence.querySelectorAll('[data-frame]')];
        const toggle = sequence.querySelector('[data-sequence-toggle]');
        let current = 0;
        let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let timer;
        let visible = false;
        const show = index => {
          current = index;
          frames.forEach((frame, i) => { frame.classList.toggle('is-active', i === index); frame.setAttribute('aria-hidden', String(i !== index)); });
        };
        const schedule = () => {
          clearInterval(timer);
          if (toggle) toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
          if (frames.length < 2 || paused || !visible || document.hidden || config.dataset.step !== '2') return;
          timer = setInterval(() => {
            if (!root.isConnected) { cleanup(); return; }
            const next = (current + 1) % frames.length;
            const img = frames[next].querySelector('img');
            if (img?.complete && img.naturalWidth) show(next);
          }, Number(sequence.dataset.delay) || 900);
        };
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
        observer.observe(sequence);
        const stepObserver = new MutationObserver(schedule);
        stepObserver.observe(config, { attributes: true, attributeFilter: ['data-step'] });
        const cleanup = () => { clearInterval(timer); observer.disconnect(); stepObserver.disconnect(); document.removeEventListener('visibilitychange', schedule); document.removeEventListener('shopify:section:unload', unload); };
        const unload = event => { if (event.target.contains(root)) cleanup(); };
        document.addEventListener('shopify:section:unload', unload);
        document.addEventListener('visibilitychange', schedule);
        toggle?.addEventListener('click', () => { paused = !paused; schedule(); });
        sequence.addEventListener('shopify:block:select', event => {
          const index = frames.indexOf(event.target.closest('[data-frame]'));
          if (index >= 0) { paused = true; show(index); schedule(); }
        });
        schedule();
      });

 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
 document.addEventListener('shopify:section:load',mount);
 document.addEventListener('shopify:section:reorder',event=>{
 const wrapper=event.target;
 const anchor=document.querySelector('[data-order-anchor="'+wrapper.id+'"]');
 if(anchor){
 if(!wrapper.closest('[data-order-sections]'))wrapper.before(anchor);
 else {
 const siblings=[...wrapper.parentElement.children].filter(x=>x.classList.contains('ds-order-section'));
 const next=siblings[siblings.indexOf(wrapper)+1];
 const nextAnchor=next && document.querySelector('[data-order-anchor="'+next.id+'"]');
 if(nextAnchor)nextAnchor.before(anchor);
 else {const anchors=[...document.querySelectorAll('[data-order-anchor]')].filter(x=>x!==anchor);anchors.at(-1)?.after(anchor);}
 }
 }
 mount();
 });
 document.addEventListener('shopify:section:unload',event=>{document.querySelector('[data-order-anchor="'+event.target.id+'"]')?.remove();});
})();
